import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { Button, Dialog, FakeText } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { BoldTableHead } from 'components/common/TableStyles';
import { DocumentLoadingContainer } from './AttachmentStyles';

const DocumentTransitionsComponent = ({ loading, stateTransitions, onCloseModal }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      id='document-transitions-dialog'
      open
      disableBackdropClick
      fullWidth
      maxWidth={'md'}
      onClose={onCloseModal}
      title={t('Offer.Edit.AttachmentsData.Transitions')}
      content={
        <Grid container justifyContent={'center'}>
          {loading && (
            <DocumentLoadingContainer>
              <FakeText lines={8} />
            </DocumentLoadingContainer>
          )}
          {!loading && (
            <Table>
              <BoldTableHead>
                <TableRow>
                  <TableCell>{t('Offer.Edit.AttachmentsData.State')}</TableCell>
                  <TableCell>{t('Offer.Edit.AttachmentsData.Date')}</TableCell>
                  <TableCell>{t('Offer.Edit.AttachmentsData.User')}</TableCell>
                </TableRow>
              </BoldTableHead>
              <TableBody>
                {stateTransitions &&
                  stateTransitions.map((transition, idx) => {
                    return (
                      <TableRow key={idx}>
                        <TableCell>{transition.stateName}</TableCell>
                        <TableCell>
                          {t('DATE_FORMAT', {
                            date: { value: transition.transitionMoment, format: 'DD.MM.YYYY HH:mm:ss' }
                          })}
                        </TableCell>
                        <TableCell>{transition.userName}</TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          )}
        </Grid>
      }
      actions={
        <Box mb={1} mx={1}>
          <Button color={'primary'} onClick={onCloseModal}>
            {t('General.Close')}
          </Button>
        </Box>
      }
    />
  );
};

DocumentTransitionsComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  stateTransitions: PropTypes.array.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default DocumentTransitionsComponent;
